export default {
  'welcome': '欢迎',
  'home': '主页',
  'dashboard.title': '主页',
  'dashboard.analysis': '分析页',
  'dashboard.monitor': '监控页',
  'dashboard.workplace': '工作台',
  'dashboard.home': '导航',
  'form.title': '表单页',
  'form.basic-form': '基础表单',
  'form.step-form.title': '分步表单',
  'form.step-form.info': '分步表单（填写转账信息）',
  'form.step-form.confirm': '分步表单（确认转账信息）',
  'form.step-form.result': '分步表单（完成）',
  'form.advanced-form': '高级表单',
  'list.title': '列表页',
  'list.table-list': '查询表格',
  'list.basic-list': '标准列表',
  'list.card-list': '卡片列表',
  'list.search-list.title': '搜索列表',
  'list.search-list.articles': '搜索列表（文章）',
  'list.search-list.projects': '搜索列表（项目）',
  'list.search-list.applications': '搜索列表（应用）',
  'profile.title': '详情页',
  'profile.basic': '基础详情页',
  'profile.advanced': '高级详情页',
  'result.title': '结果页',
  'result.success': '成功页',
  'result.fail': '失败页',
  'exception.title': '异常页',
  'exception.not-permission': '403',
  'exception.not-find': '404',
  'exception.server-error': '500',
  'exception.trigger': '触发错误',
  'account.title': '个人页',
  'account.center': '个人中心',
  'account.settings': '个人设置',
  'account.trigger': '触发报错',
  'account.logout': '退出登录',
  'dynamicForm': '动态表单',
  'logicflow': '流程图',
  'makeChart': '图表设计器(拖拽)',
  'dragChart': '图表设计器(缩放)',
  'title': '中国'
  ,'template.test':'模板'
  ,'system.script': 'SQL脚本管理'
  ,'system.target_data':'指标区间搜索'  
  ,'system.designer':'设计器'  
  ,'system.role_manage':'权限管理'  
  ,'system.target_calc':'生成指标数据'  
  ,'system.module':'模块管理'   
  ,'system.report_list':'报表管理'    
  ,'system.menu_manage':'菜单管理'      
  ,'system.report_show':'显示报表'    
  ,'system.register':'模块注册'    
  
  
  // 指标管理
  ,'targetManage.title': '指标管理',
  'targetManage.target_calc': '指标数据生成',
  'targetManage.target_data': '指标区间搜索',
  // 数据展示
  'dataShow.title': '数据展示',
  'dataShow.target_analysis': '指标分析页',
  'dataShow.report_list': '报表管理',
  // 系统管理
  'systemManage.title': '系统管理',
  'systemManage.role_manage': '权限管理',
  'systemManage.module': '模块管理',
  // 工具中心
  'toolCenter.title': '工具中心',
  'toolCenter.script': 'SQL脚本管理',
  'toolCenter.designer': '指标设计器'  ,
  'base.title': '字典管理',
  'base.dict_type': '字典类型管理',
  'base.dict_manage': '综合字典管理',  
  'base.dict_mapping': '字典映射管理',  
  'base.standard_dict': '国标字典管理', 
  'base.blend_dict': '非标字典管理', 
  'base.excel9': '分子分母明细导入',   
  
  
}
